import { useState, useCallback } from 'react';

interface ShareOptions {
  title: string;
  text: string;
  url: string;
  boardId: string;
  shareContext: 'board' | 'winners' | 'win' | 'invite';
}

// Track share event - fire and forget
const trackShare = (boardId: string, platform: string, context: string) => {
  fetch('/api/squareup/shares', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ boardId, platform, context }),
  }).catch(() => {
    // Non-blocking — don't fail the share if analytics fails
  });
};

export const useShare = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [shareOptions, setShareOptions] = useState<ShareOptions | null>(null);

  const share = useCallback((options: ShareOptions) => {
    setShareOptions(options);
    setModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalOpen(false);
    setShareOptions(null);
  }, []);

  return { share, modalOpen, shareOptions, closeModal, trackShare };
};
